import React, { useState, useEffect } from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import {
  ListView,
  ListViewHeader,
  ListViewFooter,
} from "@progress/kendo-react-listview";
import { JiraApi } from "./api";

type handler = () => void;
interface settingsProps {
  visible: boolean;
  toggleVisible: handler;
}

const TodoHeader = () => {
  return (
    <ListViewHeader
      style={{
        fontSize: 14,
        background: "#b7daf7",
      }}
      className="pl-3 pb-2 pt-2"
    >
      To Do
    </ListViewHeader>
  );
};
const InProgressHeader = () => {
  return (
    <ListViewHeader
      style={{
        fontSize: 14,
        background: "#f9ff9e",
      }}
      className="pl-3 pb-2 pt-2"
    >
      In Progress
    </ListViewHeader>
  );
};
const DoneHeader = () => {
  return (
    <ListViewHeader
      style={{
        fontSize: 14,
        background: "#c9ffcc",
      }}
      className="pl-3 pb-2 pt-2"
    >
      Done
    </ListViewHeader>
  );
};

function ItemRender(props: any) {
  const item = props.dataItem;
  return (
    <div
      className="k-listview-item"
      style={{
        margin: 0,
        padding: "5px",
        border: "1px solid #ccc",
      }}
    >
      <div style={{ marginBottom: "10px" }}> {item.summary}</div>
      <div> Date updated: {item.modificationdate.split("T")[0]}</div>
    </div>
  );
}

const Taskboard = (props: settingsProps) => {
  const [todo, SetTodo] = useState([]);
  const [InProgress, SetInProgress] = useState([]);
  const [done, Setdone] = useState([]);
  const [archive, SetArchive] = useState([]);
  useEffect(() => {
    //fetchIssues();
  }, []);
  const checkIsThisMonth = (dateString: string) => {
    const inputDate = new Date(dateString);

    // Get the current date
    const currentDate = new Date();

    // Check if the year and month of the input date match the current date's year and month
    return (
      inputDate.getFullYear() === currentDate.getFullYear() &&
      inputDate.getMonth() === currentDate.getMonth()
    );
  };
  const fetchIssues = () => {
    JiraApi.getJiraIssues().then((response: any) => {
      if (response != undefined) {
        const todoArray = [];
        const inProgressArray = [];
        const doneArray = [];
        const archiveArray = [];

        for (let i = 0; i < response.issues.length; i++) {
          const item = response.issues[i];
          if (item.fields.status.name === "Open") {
            todoArray.push({
              summary: item.fields.summary,
              modificationdate: item.fields.updated,
            });
          } else if (item.fields.status.name === "In Progress") {
            inProgressArray.push({
              summary: item.fields.summary,
              modificationdate: item.fields.updated,
            });
          } else if (item.fields.status.name === "Closed") {
            if (checkIsThisMonth(item.fields.updated)) {
              doneArray.push({
                summary: item.fields.summary,
                modificationdate: item.fields.updated,
              });
            } else {
              archiveArray.push({
                summary: item.fields.summary,
                modificationdate: item.fields.updated,
              });
            }
          }
        }

        SetTodo(todoArray);
        SetInProgress(inProgressArray);
        Setdone(doneArray);
        SetArchive(archiveArray);
      }
    });
  };
  const getUniqueYearMonthCombinations = (dateObjects: any) => {
    var uniqueYearMonths: any = [];

    for (var i = 0; i < dateObjects.length; i++) {
      var date = new Date(dateObjects[i].modificationdate);
      var year = date.getFullYear();
      var month = date.getMonth() + 1; // JavaScript months are 0-based
      var yearMonth = year + "-" + (month < 10 ? "0" + month : month); // Ensure month is zero-padded

      if (uniqueYearMonths.indexOf(yearMonth) < 0)
        uniqueYearMonths.push(yearMonth); // Store in an object to ensure uniqueness
    }

    return uniqueYearMonths.sort().reverse();
  };
  const renderItemsForYearMonth = (yearMonth) => {
    const items = archive.filter((item) => {
      const date = new Date(item.modificationdate);
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var itemYearMonth = year + "-" + (month < 10 ? "0" + month : month);
   //   console.log(itemYearMonth, yearMonth);
      return itemYearMonth === yearMonth;
    });

    // Map filtered items to JSX
    return items.map((item, index) => <li key={index}>{item.summary}</li>);
  };
  const renderArchive = () => {
    const uniqueYearMonths: any = getUniqueYearMonthCombinations(archive);

    //console.log(uniqueYearMonths);
    return (
      <div>
        {uniqueYearMonths.map((yearMonth) => (
          <div key={yearMonth}>
            <strong>{yearMonth}</strong>
            <ul style={{ listStyleType: "circle", padding: "20px" }}>
              {renderItemsForYearMonth(yearMonth)}
            </ul>
          </div>
        ))}
      </div>
    );
  };

  const renderDialog = () => {
    if (props.visible) {
      return (
        <Dialog
          title={"Fleet Service View Change Log"}
          onClose={props.toggleVisible}
          width={1050}
          height={700}
        >
          <div
            style={{ display: "inline-block", width: "320px", padding: "5px" }}
          >
            <h4>Current Sprint</h4>
            <ListView
              data={todo}
              item={ItemRender}
              header={TodoHeader}
              style={{ height: "400px" }}
            />
          </div>
          <div
            style={{ display: "inline-block", width: "320px", padding: "5px" }}
          >
            <ListView
              data={InProgress}
              item={ItemRender}
              header={InProgressHeader}
              style={{ height: "400px" }}
            />
          </div>
          <div
            style={{ display: "inline-block", width: "320px", padding: "5px" }}
          >
            <ListView
              data={done}
              item={ItemRender}
              header={DoneHeader}
              style={{ height: "400px" }}
            />
          </div>
          <div style={{ borderTop: "1px solid #ccc" }}>
            <h4>Previous Sprints</h4>
            {renderArchive()}
          </div>
          <DialogActionsBar>
            <button
              className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
              onClick={props.toggleVisible}
            >
              Close
            </button>
          </DialogActionsBar>
        </Dialog>
      );
    }
    return null;
  };
  return renderDialog();
};

export default Taskboard;
